import React, { Component } from 'react';
import axios from 'axios';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import services from '@C/Director/Utils/_utils/data';
import { TableGrid } from '@C/TableGrid';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';
import { authHeader } from '@H';

const col = [
  {
    name: 'Wallet',
    key: 'bank_name',
  },
  {
    name: 'Logo',
    key: 'all',
    formatter: (props) => {
      const logoUrl = props.logo;
      return (
        <>
          {logoUrl && (
            <img
              src={logoUrl}
              alt="Wallet Logo"
              style={{ width: '8rem', height: '100%' }}
            />
          )}
        </>
      );
    },
  },
];

const enabledActions = [
  {
    action: 'Delete',
    roles: ['DIRECTOR'],
  },
  // {
  //   action: 'Edit',
  //   roles: ['DIRECTOR'],
  // },
];

export default class WalletList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      walletList: [],
      loading: true,
      limit: 20,
      offset: 1,
      count: 0,
    };
    this.limitInput = React.createRef();
  }

  componentDidMount() {
    this.getWalletList();
  }

  getWalletList = () => {
    services
      .getWalletList()
      .then((response) => {
        this.setState({
          walletList: response.data.data,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  confirmDelete = (item) => {
    confirmAlert({
      title: 'Confirm wallet deletion',
      message: (
        <div>
          Are you sure you want to delete the <span>"{item.bank_name}"</span>
        </div>
      ),
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.deleteItem(item),
        },
        {
          label: 'No',
          onClick: () => false,
        },
      ],
    });
  };

  deleteItem = (item) => {
    const headers = authHeader();
    axios
      .delete(`${process.env.API_URL}/utils/wallets/?wallet_id=${item.uuid}`, {
        headers,
      })
      .then(() => {
        toast.success('Wallet deleted successfully', {
          position: 'bottom-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
        this.getWalletList();
      });
  };

  render() {
    const { walletList } = this.state;
    return (
      <section className="widget full-width list-table">
        <header>
          <h3>Wallet List</h3>
        </header>
        <main className="list-content">
          <div className="table-wrapper">
            {this.state.loading ? (
              <DropLoaderLarge />
            ) : (
              <TableGrid
                col={col}
                row={walletList}
                pagination="disabled"
                enableExport={false}
                onEdit={this.props.onEdit}
                onDelete={this.confirmDelete}
                enabledActions={enabledActions}
              />
            )}
          </div>
        </main>
      </section>
    );
  }
}
